var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHkgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.29 45.12H-2.165V0H62.29v45.12Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.146 21.838s-4.548-1.957-3.896-7.033c.626-2.44 1.745-4.106 3.763-5.014.952-.29 1.922-.423 2.909-.502-.265.246-.476.493-.59.793-.212.564-.054 1.092.237 1.63.361.617.582 1.251.652 2.08a3.226 3.226 0 0 1-1.286 2.97c-.582.449-1.27.608-1.833 1.119-.441.423-.705.855-.794 1.595-.017 1.419.362 1.621.838 2.362Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.366 14.47v.027h-.185v-.027h.185Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.358 17.809c.014 1.331.414 2.675 1.267 3.43l-.122.139c-.91-.805-1.316-2.21-1.33-3.567a6.529 6.529 0 0 1 .263-1.943c.179-.587.447-1.095.8-1.438l.128.133c-.322.313-.578.79-.751 1.36a6.345 6.345 0 0 0-.255 1.886ZM29.384 13.615l.29.485-.528-.22-.414.44.07-.572-.529-.22.573-.133.07-.564.292.485.581-.132",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.534 21.503s.528-4.927 5.578-5.79c2.52-.106 4.441.467 5.904 2.141.556.82.96 1.71 1.322 2.626-.308-.176-.599-.308-.934-.326-.59-.044-1.057.265-1.48.697-.494.546-1.11.969-1.798 1.233a3.225 3.225 0 0 1-3.217-.352c-.599-.432-.951-1.04-1.604-1.428a2.485 2.485 0 0 0-1.762-.3c-1.366.406-1.436.829-2.01 1.499Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.319 18.616h-.027v-.185h.027v.185Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.86 18.614c-1.269.404-2.438 1.18-2.916 2.222l-.169-.077c.51-1.11 1.737-1.91 3.03-2.321a6.539 6.539 0 0 1 1.933-.318c.614-.002 1.178.105 1.608.34l-.089.162c-.394-.214-.924-.319-1.518-.317a6.358 6.358 0 0 0-1.878.309ZM37.465 19.326l-.38.414.054-.573-.53-.264.556-.088.053-.59.3.528.563-.106-.378.414.29.53",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.868 21.855s4.847-1.058 7.262 3.463c.907 2.353.969 4.354-.15 6.266-.6.793-1.322 1.454-2.071 2.097.07-.352.097-.67.009-.987-.141-.581-.582-.925-1.128-1.19a4.68 4.68 0 0 1-1.745-1.321 3.227 3.227 0 0 1-.679-3.155c.212-.705.679-1.234.837-1.974a2.468 2.468 0 0 0-.273-1.763c-.82-1.163-1.242-1.101-2.062-1.436Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.839 27.328.017.017-.017-.017Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.791 27.41-.018-.017.131-.13.018.017-.13.13Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.668 24.097c-.785-1.076-1.89-1.938-3.025-2.062l.02-.184c1.209.132 2.355 1.04 3.154 2.137.401.55.718 1.152.915 1.735.196.582.274 1.153.189 1.638l-.182-.032c.078-.444.008-.982-.182-1.547a6.37 6.37 0 0 0-.89-1.685ZM34.451 28.694l-.52-.23.573-.132.07-.59.274.502.572-.132-.396.44.264.503-.51-.23-.397.45",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.763 22.357s2.37 4.354-1.278 7.932c-2.01 1.533-3.913 2.159-6.063 1.621-.925-.352-1.762-.855-2.6-1.401.353-.026.679-.088.96-.264.512-.3.715-.82.82-1.41a4.67 4.67 0 0 1 .776-2.054 3.225 3.225 0 0 1 2.837-1.542c.74.009 1.375.317 2.133.264.608-.079 1.084-.246 1.622-.775.88-1.102.705-1.498.793-2.38v.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.903 28.667-.009.018.009-.018Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.811 28.643.009-.018.165.083-.008.018-.166-.083Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.678 26.63c.812-1.056 1.326-2.363 1.117-3.49l.182-.033c.223 1.2-.325 2.56-1.152 3.636a6.498 6.498 0 0 1-1.41 1.364c-.504.351-1.03.584-1.52.634l-.02-.184c.449-.046.946-.262 1.435-.602.488-.34.963-.799 1.368-1.325ZM24.484 28.676l.08-.564.29.502.582-.088-.406.405.291.503-.537-.256-.406.405.07-.563-.537-.256",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.225 22.26s-3.313 3.684-7.913 1.446c-2.115-1.384-3.332-2.979-3.534-5.182.026-.996.211-1.948.45-2.908.15.317.316.599.572.81.45.38 1.014.397 1.613.3a4.582 4.582 0 0 1 2.177.053 3.225 3.225 0 0 1 2.405 2.168c.238.696.159 1.401.467 2.097.265.547.582.934 1.26 1.27 1.34.466 1.648.167 2.503-.045v-.009Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.99 20.727-.018-.009.018.01Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.014 20.635.018.01-.083.165-.018-.01.083-.165Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.835 22.66c1.266.414 2.667.466 3.657-.101l.092.16c-1.055.605-2.517.539-3.807.116a6.53 6.53 0 0 1-1.756-.874c-.499-.359-.894-.777-1.105-1.22l.167-.08c.193.406.563.802 1.046 1.15a6.342 6.342 0 0 0 1.706.848ZM21.514 19.388l.555-.115-.379.44.273.52-.51-.246-.38.44.062-.599-.52-.247.555-.114.062-.6",
    fill: "#BA0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkgFlag);
export default __webpack_public_path__ + "static/media/hkg-flag.c60a3a7bc32294833b2474f4fe1df6a5.svg";
export { ForwardRef as ReactComponent };